import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { IconButton } from '../IconButton/IconButton';
import { useIcons } from '../../hooks/useIcons';
import { useTpaasTracker } from '../../hooks/useTpaasTracker';

interface ClickToPlayProps {
  className?: string;
}

export const ClickToPlay: FunctionComponent<ClickToPlayProps> = ({
  className,
}) => {
  const { trackEngagementUIElement } = useTpaasTracker();
  const { Play } = useIcons();

  const handleClickToPlay = useCallback(
    (e: MouseEvent) => {
      if (e.currentTarget instanceof Element) {
        trackEngagementUIElement({
          elementName: 'Start',
          elementType: (e.currentTarget as Element)?.tagName.toLowerCase(),
          name: 'Play',
        });
      }
    },
    [trackEngagementUIElement]
  );

  return (
    <IconButton
      filled
      variant="circle"
      color="primary"
      className={className}
      size="large"
      onClick={handleClickToPlay}
    >
      <Play />
    </IconButton>
  );
};
